<template>
    <q-list bordered>
        <q-item-label header class="row justify-between bg-grey-4">
            <div class="text-black text-h6">{{$t('transfers.send_money_steps.amount')}}</div>
            <q-btn outline :label="$t('transfers.send_money_steps.change')" color="primary" @click="$emit('edit')"/>
        </q-item-label>

        <q-item>
            <q-item-section class="col-6">
                <q-item-label class="text-grey-7">{{$t('transfers.send_money_steps.guaranteed_rate')}}</q-item-label>
            </q-item-section>

            <q-item-section class="text-right">
                <q-item-label>
                    <span >
                        <currency-format
                            :value="displayable_rate"
                            :hide-decimals="rate_reversed"
                            hide-white-spaces
                            style="display: inline-block; font-size: 1rem"
                        />
                    </span>
                </q-item-label>
            </q-item-section>
        </q-item>
        <q-item>
            <q-item-label caption>
                <q-icon name="fa fa-triangle-exclamation" color="primary" size="xs"/>&nbsp;
                <i18n path="transfers.send_money_steps.pay_quickly_to_avoid_rate_fluctuations">
                    <template #total_amount>
                        <currency-format
                            :value="total_amount"
                            hide-zero-decimal
                            hide-white-spaces
                            style="display: inline-block"
                            :unit="transfer.from_currency_symbol"
                        />
                    </template>
                </i18n>
            </q-item-label>
        </q-item>

        <q-separator spaced />

        <q-item>
            <q-item-section class="col-4">
                <q-item-label class="text-grey-7">{{$t('transfers.send_money_steps.you_send')}}</q-item-label>
            </q-item-section>

            <q-item-section class="text-right">
                <q-item-label dir="ltr">
                            <span >
                                <currency-format
                                    :value="transfer.origin_amount"
                                    hide-zero-decimal
                                    hide-white-spaces
                                    style="display: inline-block; font-size: 1rem"
                                />
                            </span><span > {{transfer.from_currency_symbol}} </span>
                </q-item-label>
            </q-item-section>
        </q-item>

        <q-item>
            <q-item-section class="col-4">
                <q-item-label class="text-grey-7">{{$t('transfers.send_money_steps.service_fee')}}</q-item-label>
            </q-item-section>

            <q-item-section class="text-right">
                <q-item-label dir="ltr">
                            <span >
                                <currency-format :value="transfer.fees"
                                                 hide-zero-decimal
                                                 hide-white-spaces
                                                 style="display: inline-block; font-size: 1rem"
                                                 sign="+"
                                />
                            </span><span > {{transfer.from_currency_symbol}} </span>
                </q-item-label>
            </q-item-section>
        </q-item>

        <q-item>
            <q-item-section class="col-4">
                <q-item-label class="text-grey-7">{{$t('transfers.send_money_steps.rewards_discount')}}</q-item-label>
            </q-item-section>

            <q-item-section class="text-right">
                <q-item-label dir="ltr">
                    <span >
                        <currency-format
                            :value="transfer.referral_earnings"
                            hide-white-spaces
                            style="display: inline-block; font-size: 1rem"
                            hide-zero-decimal
                            sign="-"
                        />
                    </span><span > {{transfer.from_currency_symbol}} </span>
                </q-item-label>
            </q-item-section>
        </q-item>

        <q-separator spaced />

        <q-item>
            <q-item-section class="col-5">
                <q-item-label class="text-grey-7">{{$t('transfers.send_money_steps.total_to_pay')}}</q-item-label>
            </q-item-section>

            <q-item-section class="text-right col-7">
                <q-item-label dir="ltr">
                    <span class="text-primary">
                        <currency-format
                            :value="total_amount"
                             hide-zero-decimal
                             hide-white-spaces
                             style="display: inline-block; font-size: 1.3rem"
                        />
                    </span><span class="text-primary"> {{transfer.from_currency_symbol}} </span>
                </q-item-label>
            </q-item-section>
        </q-item>

        <q-item>
            <q-item-section class="col-5">
                <q-item-label class="text-grey-7">{{$t('transfers.send_money_steps.recipient_gets', {recipient: recipient.name})}}</q-item-label>
            </q-item-section>

            <q-item-section class="text-right col-7">
                <q-item-label dir="ltr">
                    <span class="text-primary">
                        <currency-format
                            :value="Number(transfer.dest_amount).roundToX(8)"
                                         hide-zero-decimal
                                         hide-white-spaces
                                         style="display: inline-block; font-size: 1.3rem"
                        />
                    </span><span class="text-primary"> {{transfer.to_currency_symbol}} </span>
                </q-item-label>
            </q-item-section>
        </q-item>
    </q-list>
</template>
<script>
export default {
    name: "ReviewAmount",
    props: {
        transfer: {
            type:Object,
            required: true
        },
        recipient: {
            type: Object,
            required: true
        },
        decimals: {
            type: Number,
            default: 2
        }
    },
    computed: {
        total_amount() {
            return parseFloat(this.transfer.origin_amount + this.transfer.service_fee - this.transfer.referral_earnings)
        },
        rate_reversed() {
            return this.transfer.rate < 0.1
        },
        displayable_rate() {
            return Number((this.rate_reversed && this.transfer.current_rate) ? (1 / this.transfer.current_rate) : this.transfer.current_rate).roundToX(this.decimals)
        },
    },
    data() {
        return {}
    },
    methods: {},
    created() {},
    mounted() {},
    components: {},
}
</script>
<style>

</style>
